export const exceededLimitParameter = 'Limite de vendas do produto';
